<template>
  <div
    v-if="sender === 'customer'"
    class="balloon balloon-text cursor-pointer"
    @click.exact="bubblePopup"
    @click.shift.left.exact="bubbleShift"
  >
    {{ message.utterance }}
  </div>
  <div
    v-else
    class="balloon balloon-text"
    @click.shift.left.exact="bubbleShift"
  >
    {{ message.utterance }}
  </div>
</template>

<script>
export default {
  name: 'PayloadVoice',
  props: {
    sessionId: String,
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    },
    bubblePopup() {
      this.$emit('learnPopup', {
        word: this.message.utterance,
        query: {
          session_id: this.sessionId,
          bot_conversation_id: this.conversation.conversation_id,
          sender: this.sender
        }
      })
    }
  }
}
</script>
